import FormStyles from '../../styles/forms/FormStyles.module.scss';

import Button from '../elements/Button';

import moment from 'moment';

import { useState, useEffect } from 'react';

import { useForm, Controller } from 'react-hook-form';
import { ReCaptcha } from '../elements/Recaptcha';

const RegisterChildForm = ({ success, setSuccess }) => {
  function formSent() {
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
    }, 18000);
  }

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaText, setCaptchaText] = useState(false);

  const [formstep, setFormStep] = useState(0);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isValid },
    trigger,
  } = useForm({
    mode: 'all',
  });

  const professional = watch('Professional');
  const allergy = watch('Allergies');
  const medicalcondition = watch('MedicalConditions');
  const religiousrequirements = watch('ReligiousRequirements');
  const currentChildcare = watch('CurrentChildcare');

  const completeFormStep = () => {
    setFormStep((cur) => cur + 1);
    document.getElementById('topOfForm')?.scrollIntoView({ behavior: 'smooth' });
  };
  const reverseFormStep = () => {
    setFormStep((cur) => cur - 1);
    document.getElementById('topOfForm')?.scrollIntoView({ behavior: 'smooth' });
  };

  // const onSubmit = (data) => {alert(JSON.stringify(data));}
  const onSubmit = async (data) => {
    setIsSubmitting(true);
    await fetch('/api/register-child', {
      method: 'post',
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.formSendSuccess) {
          formSent();
          document.getElementById('topOfForm')?.scrollIntoView({ behavior: 'smooth' });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    setIsSubmitting(false);
  };

  const validateTrigger = () => {
    trigger();
  };

  const validateMove = () => {
    completeFormStep();
  };

  return (
    <>
      <div id="topOfForm"></div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${FormStyles.registerform} contactform`}></div>

        {formstep === 0 && (
          <section>
            <div className="halfgrid" style={{ gap: `0 2rem` }}>
              <div className="firsthalf">
                <input value={moment().format('MM ddd, YYYY hh:mm')} {...register('DateTime')} type="hidden" />
                <div className={`${FormStyles.formField} ${errors.FirstName && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="FirstName">Child first name</label>
                  <input defaultValue="" {...register('FirstName', { required: true })} />
                  {errors.FirstName && <span>Please enter the childs first name</span>}
                </div>
                <div className={`${FormStyles.formField} ${errors.SurName && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="SurName">Child surname</label>
                  <input defaultValue="" {...register('SurName', { required: true })} />
                  {errors.SurName && <span>Please enter the childs surname</span>}
                </div>
                <div className={`${FormStyles.formField} ${errors.KnownName && 'error-input'}`}>
                  <label htmlFor="KnownName">Child known Name</label>
                  <input defaultValue="" {...register('KnownName', { required: false })} />
                  {errors.KnownName && <span>Please enter the childs known name</span>}
                </div>
                <div className={`${FormStyles.formField} ${errors.Sex && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="Sex">Sex of your child</label>

                  <select defaultValue={''} {...register('Sex', { required: true })}>
                    <option disabled value="">
                      Please Select
                    </option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="unknown">Unknown (Currently Pregnant)</option>
                  </select>
                  {errors.Sex && <span>Please enter your childs sex</span>}
                </div>
                <div className={`${FormStyles.formField} ${errors.EthnicGroup && 'error-input'}`}>
                  <label htmlFor="EthnicGroup">Ethnic group</label>
                  <input defaultValue="" {...register('EthnicGroup', { required: false })} />
                  {errors.EthnicGroup && <span>Please enter the childs ethnic group</span>}
                </div>
              </div>
              <div className="secondhalf">
                <div className={`${FormStyles.formField} ${errors.DateofBirth && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="DateofBirth">Child date of birth</label>
                  <input type="date" defaultValue="" {...register('DateofBirth', { required: true })} />
                  {errors.DateofBirth && <span>Please enter please enter the date of birth</span>}
                </div>
                <div className={`${FormStyles.formField} ${errors.FirstLanguage && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="FirstLanguage">First language at home</label>
                  <input defaultValue="" {...register('FirstLanguage', { required: true })} />
                  {errors.FirstLanguage && <span>Please enter the first language at home</span>}
                </div>
                <div className={`${FormStyles.formField} ${errors.Otheranguage && 'error-input'}`}>
                  <label htmlFor="Otheranguage">Other languages at home</label>
                  <input defaultValue="" {...register('Otheranguage', { required: false })} />
                </div>
                <div className={`${FormStyles.formField} ${errors.ChildHealthBook && 'error-input'}`}>
                  <label htmlFor="ChildHealthBook">Does your child have a Personal Child Health Book - Red Book</label>
                  <select {...register('ChildHealthBook', { required: true })}>
                    <option defaultValue value="Yes - Please bring to your first settling session at the nursery">
                      Yes - Please bring to your first settling session at the nursery
                    </option>
                    <option value="No - Please bring any health documents with you to the first settling session so that we can record vaccinations etc.">
                      No - Please bring any health documents with you to the first settling session so that we can record vaccinations etc.
                    </option>
                  </select>
                  {errors.Subject && <span>Please inform us whether your child has a Personal Book of Health</span>}
                </div>
              </div>
            </div>

            <div className={FormStyles.NavHolder}>
              {formstep > 0 && (
                <button type="button" onClick={reverseFormStep} className={FormStyles.Prev}>
                  Prev
                </button>
              )}
              {!captchaText ? (
                <ReCaptcha buttonText={'Please prove you are human'} colour={'#CB8799'} captchaText={captchaText} setCaptchaText={setCaptchaText} />
              ) : (
                <button type="button" onClick={isValid ? validateMove : validateTrigger} className={FormStyles.Submit}>
                  Next
                </button>
              )}
            </div>
          </section>
        )}

        {formstep === 1 && (
          <section>
            <div className="halfgrid" style={{ gap: `0 2rem` }}>
              <div className="firsthalf">
                <div className={`${FormStyles.formField} ${errors.Professional && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="Professional">Are there any professionals involved in your childs care - ie speech and language or social worker etc Do not include Health Visitor</label>
                  <select defaultValue={''} {...register('Professional', { required: true })}>
                    <option disabled value="">
                      Please Select
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  {errors.Professional && <span>Please inform us whether any professionals are involved</span>}
                </div>

                {professional == 'Yes' && (
                  <div className={`${FormStyles.formField} ${errors.ProfessionalDetails && 'error-input'}`}>
                    <label htmlFor="ProfessionalDetails">Please provide details about the professional</label>
                    <textarea rows="5" {...register('ProfessionalDetails', { required: true })} />
                    {errors.ProfessionalDetails && <span>Please provide details of these professionals</span>}
                  </div>
                )}

                <div className={`${FormStyles.formField} ${errors.Allergies && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="Allergies">Has your child any known food allergies or special dietary requirements</label>
                  <select defaultValue={''} {...register('Allergies', { required: true })}>
                    <option disabled value="">
                      Please Select
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  {errors.Allergies && <span>Please inform us whether your child has allergies</span>}
                </div>

                {allergy == 'Yes' && (
                  <div className={`${FormStyles.formField} ${errors.AllergyDetails && 'error-input'}`}>
                    <div className={FormStyles.required}>*</div>
                    <label htmlFor="AllergyDetails">Please provide details about the allergies</label>
                    <textarea rows="5" {...register('AllergyDetails', { required: true })} />
                    {errors.AllergyDetails && <span>Please enter your message</span>}
                  </div>
                )}
              </div>

              <div className="secondhalf">
                <div className={`${FormStyles.formField} ${errors.ReligiousRequirements && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="ReligiousRequirements">Does your child have any cultural or religious requirements</label>
                  <select defaultValue={''} {...register('ReligiousRequirements', { required: true })}>
                    <option disabled value="">
                      Please Select
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  {errors.ReligiousRequirements && <span>Please inform us of any cultural or religious requirements</span>}
                </div>

                {religiousrequirements == 'Yes' && (
                  <div className={`${FormStyles.formField} ${errors.ReligiousDetails && 'error-input'}`}>
                    <div className={FormStyles.required}>*</div>
                    <label htmlFor="ReligiousDetails">Please provide further details about the religious requirements</label>
                    <textarea rows="5" {...register('ReligiousDetails', { required: true })} />
                    {errors.ReligiousDetails && <span>Please inform us of any religious requirements</span>}
                  </div>
                )}

                <div className={`${FormStyles.formField} ${errors.MedicalConditions && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="MedicalConditions">Does your child have any medical conditions</label>
                  <select defaultValue={''} {...register('MedicalConditions', { required: true })}>
                    <option disabled value="">
                      Please Select
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  {errors.MedicalConditions && <span>Please inform us of any medical conditions</span>}
                </div>

                {medicalcondition == 'Yes' && (
                  <div className={`${FormStyles.formField} ${errors.MedicalConditionDetails && 'error-input'}`}>
                    <div className={FormStyles.required}>*</div>
                    <label htmlFor="MedicalConditionDetails">Please provide further details about these conditions</label>
                    <textarea rows="5" {...register('MedicalConditionDetails', { required: true })} />
                    {errors.MedicalConditionDetails && <span>Please tells us what the medical conditions are</span>}
                  </div>
                )}
              </div>
            </div>
            <div className={FormStyles.NavHolder}>
              {formstep > 0 && (
                <button type="button" onClick={reverseFormStep} className={FormStyles.Prev}>
                  Prev
                </button>
              )}

              <button type="button" onClick={isValid ? validateMove : validateTrigger} className={FormStyles.Submit}>
                Next
              </button>
            </div>
          </section>
        )}

        {formstep === 2 && (
          <section>
            <div className="halfgrid" style={{ gap: `0 2rem` }}>
              <div className="firsthalf">
                <div className={`${FormStyles.formField} ${errors.ParentCarer1FirstName && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="ParentCarer1FirstName">Parent or Carer 1 First Name</label>
                  <input defaultValue="" {...register('ParentCarer1FirstName', { required: true })} />
                  {errors.ParentCarer1FirstName && <span>Please enter the parent or carers first name</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.ParentCarer1LastName && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="ParentCarer1LastName">Parent or Carer 1 Last Name</label>
                  <input defaultValue="" {...register('ParentCarer1LastName', { required: true })} />
                  {errors.ParentCarer1LastName && <span>Please enter the parent or carers Last name</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.ParentCarer1Address && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="ParentCarer1Address">Parent or Carer 1 Address and Postcode</label>
                  <textarea rows="5" defaultValue="" {...register('ParentCarer1Address', { required: true })} />
                  {errors.ParentCarer1Address && <span>Please enter the parent or carers address</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.Parent1HomeNumbers && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="Parent1HomeNumbers">Parent 1 Home phone number</label>
                  <input defaultValue="" {...register('Parent1HomeNumbers', { required: true })} />
                  {errors.Parent1HomeNumbers && <span>Please enter the parent or carers home number</span>}
                </div>
              </div>
              <div className="secondhalf">
                <div className={`${FormStyles.formField} ${errors.Parent1Email && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="Parent1Email">Parent 1 Email Address</label>
                  <input defaultValue="" {...register('Parent1Email', { required: true })} />
                  {errors.Parent1Email && <span>Please enter the parent or carers email address</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.Parent1Workplace && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="Parent1Workplace">Parent 1 Name of Workplace</label>
                  <input defaultValue="" {...register('Parent1Workplace', { required: false })} />
                  {errors.Parent1Workplace && <span>Please enter the parent or carers workplace </span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.Parent1WorkplaceAddress && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="Parent1WorkplaceAddress">Parent 1 Address of workplace including postcode</label>
                  <input defaultValue="" {...register('Parent1WorkplaceAddress', { required: false })} />
                  {errors.Parent1WorkplaceAddress && <span>Please enter the parent or carers workplace address</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.Parent1WorkPhone && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="Parent1WorkPhone">Parent 1 Workplace Phone number</label>
                  <input defaultValue="" {...register('Parent1WorkPhone', { required: false })} />
                  {errors.Parent1WorkPhone && <span>Please enter the parent or carers workplace phone number</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.ParentCarer1ParentalResponsibility && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="ParentCarer1ParentalResponsibility">Does Parent/Carer 1 have parental responsibility?</label>
                  <select defaultValue={''} {...register('ParentCarer1ParentalResponsibility', { required: true })}>
                    <option disabled value="">
                      Please Select
                    </option>
                    <option value="Yes, they do">Yes, they do</option>
                    <option value="No, they do not">No, they do not</option>
                  </select>
                  {errors.ParentCarer1ParentalResponsibility && <span>Please state whether the parent or carers have responsibility</span>}
                </div>
              </div>
            </div>
            <div className={FormStyles.NavHolder}>
              {formstep > 0 && (
                <button type="button" onClick={reverseFormStep} className={FormStyles.Prev}>
                  Prev
                </button>
              )}

              <button type="button" onClick={isValid ? validateMove : validateTrigger} className={FormStyles.Submit}>
                Next
              </button>
            </div>
          </section>
        )}

        {formstep === 3 && (
          <section>
            <div className="halfgrid" style={{ gap: `0 2rem` }}>
              <div className="firsthalf">
                <div className={`${FormStyles.formField} ${errors.ParentCarer2FirstName && 'error-input'}`}>
                  <label htmlFor="ParentCarer2FirstName">Parent or Carer 2 First Name</label>
                  <input defaultValue="" {...register('ParentCarer2FirstName', { required: false })} />
                  {errors.ParentCarer2FirstName && <span>Please enter the parent or carers first name</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.ParentCarer2LastName && 'error-input'}`}>
                  <label htmlFor="ParentCarer2LastName">Parent or Carer 2 Last Name</label>
                  <input defaultValue="" {...register('ParentCarer2LastName', { required: false })} />
                  {errors.ParentCarer2LastName && <span>Please enter the parent or carers Last name</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.ParentCarer2Address && 'error-input'}`}>
                  <label htmlFor="ParentCarer2Address">Parent or Carer 2 Address and Postcode</label>
                  <textarea rows="5" defaultValue="" {...register('ParentCarer2Address', { required: false })} />
                  {errors.ParentCarer2Address && <span>Please enter the parent or carers address</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.Parent2HomeNumbers && 'error-input'}`}>
                  <label htmlFor="Parent2HomeNumbers">Parent 2 Home phone number</label>
                  <input defaultValue="" {...register('Parent2HomeNumbers', { required: false })} />
                  {errors.Parent2HomeNumbers && <span>Please enter the parent or carers home number</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.Parent2Workplace && 'error-input'}`}>
                  <label htmlFor="Parent2Workplace">Parent 2 Name of Workplace</label>
                  <input defaultValue="" {...register('Parent2Workplace', { required: false })} />
                  {errors.Parent2Workplace && <span>Please enter the parent or carers workplace </span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.Parent2WorkplaceAddress && 'error-input'}`}>
                  <label htmlFor="Parent2WorkplaceAddress">Parent 2 Address of workplace including postcode</label>
                  <input defaultValue="" {...register('Parent2WorkplaceAddress', { required: false })} />
                  {errors.Parent2WorkplaceAddress && <span>Please enter the parent or carers workplace address</span>}
                </div>
              </div>
              <div className="secondhalf">
                <div className={`${FormStyles.formField} ${errors.Parent2WorkPhone && 'error-input'}`}>
                  <label htmlFor="Parent2WorkPhone">Parent 2 Workplace Phone number</label>
                  <input defaultValue="" {...register('Parent2WorkPhone', { required: false })} />
                  {errors.Parent2WorkPhone && <span>Please enter the parent or carers workplace phone number</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.ParentCarer2ParentalResponsibility && 'error-input'}`}>
                  <label htmlFor="ParentCarer2ParentalResponsibility">Does Parent/Carer 2 have parental responsibility?</label>
                  <select defaultValue={''} {...register('ParentCarer2ParentalResponsibility', { required: false })}>
                    <option disabled value="">
                      Please Select
                    </option>
                    <option value="Yes, they do">Yes, they do</option>
                    <option value="No, they do not">No, they do not</option>
                  </select>
                  {errors.ParentCarer2ParentalResponsibility && <span>Please state whether the parent or carers have responsibility</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.Parent2Email && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="Parent2Email">Parent 2 Email Address</label>
                  <input defaultValue="" {...register('Parent2Email', { required: false })} />
                  {errors.Parent2Email && <span>Please enter the parent or carers email address</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.EmergencyContactName && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="EmergencyContactName">Emergency Contact First and Last Name</label>
                  <input defaultValue="" {...register('EmergencyContactName', { required: true })} />
                  {errors.EmergencyContactName && <span>Please enter the emergency contacts first and last name</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.EmergencyRelation && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="EmergencyRelation">Emergency Contact relationship to you?</label>
                  <input defaultValue="" {...register('EmergencyRelation', { required: true })} />
                  {errors.EmergencyRelation && <span>Please enter their relationship</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.EmergencyNumber && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="EmergencyNumber">Emergency Contact Phone Number</label>
                  <input defaultValue="" {...register('EmergencyNumber', { required: true })} />
                  {errors.EmergencyNumber && <span>Please enter an emergency number</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.EmergencyAddress && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="EmergencyAddress">Emergency Contact Email Address</label>
                  <input defaultValue="" {...register('EmergencyAddress', { required: true })} />
                  {errors.EmergencyAddress && <span>Please enter an emergency email address</span>}
                </div>
              </div>
            </div>
            <div className={FormStyles.NavHolder}>
              {formstep > 0 && (
                <button type="button" onClick={reverseFormStep} className={FormStyles.Prev}>
                  Prev
                </button>
              )}

              <button type="button" onClick={isValid ? validateMove : validateTrigger} className={FormStyles.Submit}>
                Next
              </button>
            </div>
          </section>
        )}

        {formstep === 4 && (
          <section>
            <div className="halfgrid" style={{ gap: `0 2rem` }}>
              <div className="firsthalf">
                <div className={`${FormStyles.formField} ${errors.NurseryPreference && 'error-input'}`}>
                  <label htmlFor="NurseryPreference">
                    Do you have a preference for which nursery your child attends You will be offered a space at the nursery which has first availability but we will do our best to place your child in the nursery of your choice
                  </label>
                  <select {...register('NurseryPreference', { required: true })}>
                    <option defaultValue value="No preference">
                      No preference
                    </option>

                    <option value="Yes, I would prefer More2Childcare">Yes, I would prefer More2Childcare</option>
                    <option value="Yes, I would prefer More2Riverside">Yes, I would prefer More2Riverside</option>
                  </select>
                  {errors.NurseryPreference && <span>Please choose your Nursery Preference</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.RequiredStartDate && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="RequiredStartDate">Required Start date at the nursery</label>
                  <input type="date" defaultValue="" {...register('RequiredStartDate', { required: true })} />
                  {errors.RequiredStartDate && <span>Please enter the required start date</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.TypeOfCare && 'error-input'}`}>
                  <label htmlFor="TypeOfCare">Type of Care Required</label>
                  <select {...register('TypeOfCare', { required: true })}>
                    <option defaultValue value="Traditional Care - All Year Round">
                      Traditional Care - All Year Round
                    </option>
                    <option value="Ad Hoc - Creche">Ad Hoc - Creche</option>
                  </select>
                  {errors.TypeOfCare && <span>Please enter the type of care required</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.DaysOfCare && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="DaysOfCare">Please specify each day of care you require - ie Monday, Wednesday, Thursday, Friday or Monday-Friday. There is a 3 day minimum booking. One of your selected days must include a Monday or Friday</label>
                  <textarea rows="5" defaultValue="" {...register('DaysOfCare', { required: true })} />
                  {errors.DaysOfCare && <span>Please enter the cdays required</span>}
                </div>
              </div>
              <div className="secondhalf">
                <div className={`${FormStyles.formField} ${errors.GovernmentAssistance && 'error-input'}`}>
                  <label htmlFor="GovernmentAssistance">
                    When you child starts nursery will you be eligible for government assistance for working parents (15 or 30 funded hours)? To be eligible both parents/carers or lone parent must a) Each be working at least 16 hrs per week b) Each
                    earn less than £100,000 per year
                  </label>
                  <select {...register('GovernmentAssistance', { required: false })}>
                    <option defaultValue value="Not Sure">
                      Not Sure
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  {errors.GovernmentAssistance && <span>Please let us know if your child is eligible for funding</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.ChildCareFunding && 'error-input'}`}>
                  <label htmlFor="ChildCareFunding">
                    Are you eligible for &quot;Together for Two&apos;s&quot;? This is 15 hours term-time free or subsidised childcare, funded by the Local Authority. It is for families who are in receipt of support (eg on benefits such as Income
                    Support/Universal Credit or low income under £16190 per year)
                  </label>
                  <select {...register('ChildCareFunding', { required: false })}>
                    <option defaultValue value="Not Sure">
                      Not Sure
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  {errors.ChildCareFunding && <span>Please let us know if your child is eligible for funding</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.CurrentChildcare && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="CurrentChildcare">Is your child currently attending a childcare setting?</label>
                  <select defaultValue={''} {...register('CurrentChildcare', { required: true })}>
                    <option disabled value="">
                      Please Select
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="N/A">N/A</option>
                  </select>
                  {errors.CurrentChildcare && <span>Please inform us if your child is currently attending a childcare setting</span>}
                </div>

                {currentChildcare === 'Yes' && (
                  <>
                    <div className={`${FormStyles.formField} ${errors.ChildcareDetails && 'error-input'}`}>
                      <div className={FormStyles.required}>*</div>
                      <label htmlFor="ChildcareDetails">Please state the business name and location</label>
                      <input defaultValue="" {...register('ChildcareDetails', { required: currentChildcare === 'Yes' })} />
                      {errors.ChildcareDetails && <span>Please provide the business name and location</span>}
                    </div>

                    <div className={`${FormStyles.formField} ${errors.DataConsent && 'error-input'}`}>
                      <div className={FormStyles.required}>*</div>
                      <label htmlFor="DataConsent">
                        If you accept a place at More2, do you give your consent that we can collect data from your existing childcare provider regarding your child&apos;s development and any relevant safeguarding information?
                      </label>
                      <select defaultValue={''} {...register('DataConsent', { required: currentChildcare === 'Yes' })}>
                        <option disabled value="">
                          Please Select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                      {errors.DataConsent && <span>Please inform us if you consent to data collection from your current childcare provider</span>}
                    </div>
                  </>
                )}

                <div className={`${FormStyles.formField} ${errors.AdditionalRequirement && 'error-input'}`}>
                  <label htmlFor="AdditionalRequirement">Please use this space to include any other information about your requirements for example if you are flexible on which days which will help us find you a place at the nursery</label>
                  <textarea rows="5" defaultValue="" {...register('AdditionalRequirement', { required: false })} />
                  {errors.AdditionalRequirement && <span>Please enter any additional requirements</span>}
                </div>

                <div className={`${FormStyles.formField} ${errors.FormAgreement && 'error-input'}`}>
                  <div className={FormStyles.required}>*</div>
                  <label htmlFor="FormAgreement">Please print your name below to certify you agree with all the information entered in the form</label>
                  <textarea rows="3" defaultValue="" {...register('FormAgreement', { required: true })} />
                  {errors.FormAgreement && <span>Please print your name in the space provided</span>}
                </div>
              </div>
            </div>
            <div className={FormStyles.NavHolder}>
              {formstep > 0 && (
                <button type="button" onClick={reverseFormStep} className={FormStyles.Prev}>
                  Prev
                </button>
              )}

              <button type="submit" className={FormStyles.Submit} disabled={isSubmitting ? 'disabled' : ''}>
                {isSubmitting ? (
                  <>
                    Submitting
                    <span className="loading-dots">.</span>
                    <span className="loading-dots">.</span>
                    <span className="loading-dots">.</span>
                  </>
                ) : (
                  'Submit'
                )}
              </button>
            </div>
          </section>
        )}
        {/*
        <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </form>
    </>
  );
};

export default RegisterChildForm;
